/**
 * @param tableView for which we want to get the context folder id
 * @return Returns folderId for the table view
 */
export default function getContextFolderIdForTable(tableView) {
    return tableView.tableQuery.type == 0 /* Folder */ ? tableView.serverFolderId : null;
}
//# sourceMappingURL=getContextFolderIdForTable.js.map